/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialLangViewModel } from "../types/CourseFinancialLangViewModel.ts";

export const courseFinancialLangViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de idioma do plano."),
  ),
  courseFinancialId: z.optional(
    z.number().int().describe("ID do plano financeiro."),
  ),
  cultureInfo: z.string().describe("Cultura do registro.").nullish(),
  languageName: z
    .string()
    .describe(
      "Nome do idioma no idioma padrão do sistema. Vazio quando a cultura não é uma das principais do LMS.",
    )
    .nullish(),
  description: z
    .string()
    .describe("Descrição do plano neste idioma.")
    .nullish(),
}) as unknown as ToZod<CourseFinancialLangViewModel>;
